import { type CSSProperties, styled } from "styled-components";

export const formStyles: CSSProperties = {
  maxWidth: 1280,
  margin: "0 auto",
  paddingBottom: 40,
};

export const StyledFormGroupsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`;
StyledFormGroupsContainer.displayName = "StyledFormGroupsContainer";
